import EventBus from "../event-bus";
import { getDraftIdFromContext } from "../utils/draftService";

export default {
    data() {
        return {
            shareLoading: false
        };
    },
    
    mounted() {
        EventBus.on("shareContent", this.shareContent);
    },
    
    beforeUnmount() {
        EventBus.off("shareContent", this.shareContent);
    },
    
    methods: {
        async shareContent() {
            this.shareLoading = true;
            
            const shareData = {
                title: "Mein personalisiertes Buch",
                text: "Hey! 👋 Ich habe dieses Buch erstellt. Wie findest du es?"
            };
            
            const shareUrl = this.buildShareUrl();
            
            try {
                if (this.hasNativeShare(shareData.title, shareData.text, shareUrl)) {
                    await navigator.share({
                        title: shareData.title,
                        text: shareData.text,
                        url: shareUrl
                    });
                } else {
                    this.showFallbackShareOptions(shareData, shareUrl);
                }
            } catch (error) {
                // sentry-ignore: sharing falls back to the share options dialog
                if (error.name !== 'AbortError') {
                    console.error('[shareMixin] Share failed:', error);
                    this.showFallbackShareOptions(shareData, shareUrl);
                }
            } finally {
                this.shareLoading = false;
            }
        },
        
        buildShareUrl() {
            const currentUrl = window.location.href;
            let draftId = getDraftIdFromContext();
            
            if (!draftId && process.env.VUE_APP_DEV_MODE === "true") {
                draftId = "dev-placeholder-draft-id-12345";
            }
            
            if (currentUrl.includes('draft-id=')) {
                return currentUrl;
            }
            
            if (draftId) {
                const separator = currentUrl.includes('?') ? '&' : '?';
                return `${currentUrl}${separator}draft-id=${draftId}`;
            }
            
            return currentUrl;
        },
        
        hasNativeShare(title, text, url) {
            return navigator.share && navigator.canShare && navigator.canShare({ 
                title: title,
                text: text,
                url: url 
            });
        },
        
        showFallbackShareOptions(shareData, shareUrl) {
            const options = [
                {
                    name: 'WhatsApp',
                    action: () => this.shareWhatsApp(shareData.text, shareUrl)
                },
                {
                    name: 'E-Mail',
                    action: () => this.shareEmail(shareData.title, shareData.text, shareUrl)
                },
                {
                    name: 'Link kopieren',
                    action: () => this.copyLink(shareUrl)
                }
            ];
            
            options[0].action();
        },
        
        shareWhatsApp(text, url) {
            const whatsappText = encodeURIComponent(`${text} ${url}`);
            const whatsappUrl = `https://wa.me/?text=${whatsappText}`;
            window.open(whatsappUrl, '_blank');
        },
        
        shareEmail(title, text, url) {
            const subject = encodeURIComponent(title);
            const body = encodeURIComponent(`${text}\n\n${url}`);
            const emailUrl = `mailto:?subject=${subject}&body=${body}`;
            window.location.href = emailUrl;
        },
        
        async copyLink(url) {
            try {
                await navigator.clipboard.writeText(url);
                
                EventBus.emit('showMessage', {
                    type: 'success',
                    message: 'Link kopiert!'
                });
                
            } catch (error) {
                // sentry-ignore: copying falls back to a manual textarea copy
                console.error('[shareMixin] Copy failed:', error);
                
                const textArea = document.createElement('textarea');
                textArea.value = url;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                
                EventBus.emit('showMessage', {
                    type: 'success',
                    message: 'Link kopiert!'
                });
            }
        }
    }
}; 
